let choicesLoaderPromise;

/**
 * Lazily load Choices.js plus its base stylesheet.
 *
 * This keeps Choices out of the initial JS/CSS payload and only loads it on pages
 * where a controller actually instantiates Choices.
 */
export async function loadChoices() {
  if (!choicesLoaderPromise) {
    choicesLoaderPromise = (async () => {
      // Ensure base styles are present before instantiation.
      await import("choices.js/public/assets/styles/choices.min.css");

      const module = await import("choices.js");
      return module?.default ?? module;
    })();
  }

  return choicesLoaderPromise;
}
